// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__kkCmP","content":"ManualTimeModal_content__FG8NQ"};